<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12">
            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3" style="display:inline;clear:none;">{{ "LOAD_STUDENTS" |
                    translate
                    | titlecase }}</h5>
                <app-loader [show]="showLoader"></app-loader>
                <br>
                <div id="accordion" *ngIf="showLoader==false">
                    <div class="card">
                        <div id="collapseOne">
                            <div class=" card-body">
                                <form [formGroup]="searchForm" (change)="searchFormChange()"
                                    (submit)="searchFormSubmit()">
                                    <div class="row">
                                        <div class="col-md-4 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "ACADMIC_YEAR" | translate | titlecase
                                                }}</label>
                                            <select class="form-control custom-select" formControlName="year"
                                                (change)="getYearSemesters()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of years" [value]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.yearDescAr : field?.yearDescEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.year.touched && searchForm.controls.year.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-4 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "SEMESTER" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="semester"
                                                (change)="getBatches()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of semesters" [value]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.semesterNameAr :
                                                    field?.semesterNameEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.semester.touched && searchForm.controls.semester.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-4 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "BATCH" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="batch">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of batches" [value]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.gradeNameAr : field?.gradeNameEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.batch.touched && searchForm.controls.batch.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <!-- <div class="col-md-4 form-group px-md-5 mb-1">
                                            <label class="font-bold"> {{ "COURSE" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="course">
                                                <option value="" [selected]="true">{{ "SELECT" | translate |
                                                    titlecase
                                                    }}</option>
                                                <option *ngFor="let field of courses" [value]="field.id">
                                                    {{(globals.lang == 'ar')? field.subjectNameAr :
                                                    field.subjectNameEn}} - ({{field.subjectCode}})</option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.course.touched && searchForm.controls.course.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div> -->
                                        <div class="col-md-6 form-group px-md-5 mb-1"
                                            style="padding-top: 23px !important;">
                                            <button type="submit" class="btn btn-primary">
                                                {{ "SEARCH" | translate | titlecase }}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <br>

                <div class="row" *ngIf="Searched">
                    <div class="col-md-4 form-group px-md-5 mb-1">
                        <!-- <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="globals.checkUserHasPermission('COUNTRIES - CREATE')"> -->
                        <!-- <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                            routerLink="/scores-grades/scores-data-upload/create"
                            [queryParams]="{yearId: currentYear, semesterId: currentSemester, batchId: currentBatch, courseId: currentCourse}"><i
                                class="fas fa-plus"></i> {{ "ADD" |
                            translate |
                            titlecase }}</button> -->
                        <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                            (click)="loadAndReloadStudent()"><i class="fas fa-plus"></i> {{ "LOAD_RELOAD" |
                            translate |
                            titlecase }}</button>
                    </div>
                </div>


                <br />
                <div class="table-responsive py-3" *ngIf="!showLoader">
                    <table *ngIf="studentCourses.length >= 1&& Searched" class="table-striped" id="datatable">
                        <thead>
                            <tr>
                                <th>{{ "ID" | translate | titlecase }}</th>
                                <th>{{ "COURSE" | translate | titlecase }}</th>
                                <th>{{ "REMARKS" | translate | titlecase }}</th>
                                <th class="border-0 font-14 px-2 text-grey"></th>
                                <th>{{ "STATUS" | translate | titlecase }}</th>
                                <th class="border-0 font-14 px-2 text-grey"></th>
                                <th class="border-0 font-14 px-2 text-grey"></th>
                                <th class="border-0 font-14 px-2 text-grey"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let res of studentCourses let i = index">
                                <td>{{res?.id}}</td>
                                <td>{{ res?.course?.subjectCode + " | " }}
                                    {{
                                    (globals.lang == 'ar')? res?.course?.subjectNameAr : res?.course?.subjectNameEn
                                    }}
                                </td>
                                <td>{{res?.remarks}}</td>
                                <td class="text-bold">
                                    <a class="btn btn-sm btn-link text-warning" data-toggle="modal"
                                        data-target="#editStudentCourseRemarkFile" href="#"
                                        (click)="updateCurrentCourseId(res?.id, res?.remarks)"
                                        title="{{ 'EDIT_REMARKS' | translate | titlecase }}"
                                        *ngIf="res?.headerStatus == 'DRAFT'"><i class="fas fa-edit"
                                            style="font-size: 25px;"></i></a>
                                </td>
                                <td>{{res?.headerStatus}}</td>

                                <td class="text-bold">
                                    <button type="button" class="btn btn-primary"
                                        (click)="updateCourseStatus(res?.id, 1)" *ngIf="res?.headerStatus == 'DRAFT'">
                                        {{ "SUBMIT" | translate | titlecase }}</button>
                                </td>
                                <td class="text-bold text-warning">
                                    <button type="button" class="btn btn-danger" data-toggle="modal"
                                        data-target="#cancelExam" (click)="updateCurrentCourseId(res?.id)"
                                        *ngIf="res?.headerStatus == 'SUBMITTED'">
                                        {{ "CANCEL" | translate | titlecase }}</button>
                                </td>
                                <td class="text-bold">
                                    <button type="button" class="btn btn-info" data-toggle="modal"
                                        data-target="#studentDetails" (click)="getStudentDetails(res?.id, res?.course)">
                                        {{ "STUDENTS_DETAILS" | translate | titlecase }}</button>
                                </td>
                                <!-- <td class="text-bold">
                                    <button type="button" class="btn btn-danger" data-toggle="modal"
                                        data-target="#deleteExam" (click)="updateCurrentCourseId(res?.id)"
                                        *ngIf="res?.headerStatus == 'DRAFT'">
                                        {{ "DELETE" | translate | titlecase }}</button>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal DisableServiceData-->
<div class="modal fade" id="studentDetails" tabindex="-1" aria-labelledby="studentDetails" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered student-detail-modal">
        <form class="modal-content col-md-12">
            <div class="row">
                <div class="col-sm-1">
                    <button (click)="exportDate()" class="btn" style="height:auto"><span
                            style="font-size: 2em; color: green;"><i
                                class="fas fa-file-excel fa-sm"></i></span></button>
                </div>
            </div>
            <div class="modal-header">
                <h5 class="modal-title" id="DisableServiceDataLabel">{{ "STUDENT_DETAILS" | translate | titlecase
                    }}: <span class="alert alert-secondary" role="alert" *ngIf="currentCourseObj">{{ (globals.lang ==
                        'ar')? currentCourseObj.subjectCode + ' | ' + currentCourseObj?.subjectNameAr :
                        currentCourseObj.subjectCode + ' | ' + currentCourseObj?.subjectNameEn}}</span></h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="card-body">
                <!-- <div class="col-md-2.5 px-md-5 form-group" >
                    <button type="button" class="btn btn-primary" (click)="exportDate()">
                        <span style="font-size: 1.5em; color: white;"><i class="fas fa-file-excel fa-sm"></i></span> {{ "EXPORT" | translate | titlecase }}</button>
                </div> -->
                <!-- <div class="row">
                    <div class="col-sm-1">
                        <button (click)="exportDate()" class="btn" style="height:auto"><span
                                style="font-size: 2em; color: green;"><i
                                    class="fas fa-file-excel fa-sm"></i></span></button>
                    </div>
                </div> -->
                <app-loader [show]="loadStudentDetails"></app-loader>
                
                <table id="student-details-table" class="table table-bordered"
                    *ngIf="studentDetails.length > 0 && !loadStudentDetails">
                    <thead>
                        <tr>
                            <th>{{ "ID" | translate | titlecase }}</th>
                            <th>{{ "MAT_NO" | translate | titlecase }}</th>
                            <th>{{ "FULL_NAME" | translate | titlecase }}</th>
                            <th>{{ "EXAM_STATUS" | translate | titlecase }}</th>
                            <th>{{ "ATTENDNCE_ELIGBILITY" | translate | titlecase }}</th>
                            <th>{{ "ON_GOING" | translate | titlecase }}</th>
                            <th>{{ "ON_GOING_ELIGIBILITY" | translate | titlecase }}</th>
                            <th>{{ "CLINICAL" | translate | titlecase }}</th>
                            <th>{{ "CLINICAL_ELIGIBILITY" | translate | titlecase }}</th>
                            <th>{{ "GRADE" | translate | titlecase }}</th>
                            <th>{{ "GPA" | translate | titlecase }}</th>
                            <th>{{ "STATUS" | translate | titlecase }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of studentDetails let i = index">
                            <td>{{data?.id}}</td>
                            <td>{{data?.studentid}}</td>
                            <td> {{
                                (globals.lang == 'ar')? data?.studentFullnameAr :
                                data?.studentFullnameEn
                                }}</td>
                            <td>{{data?.subjectStatus}}</td>
                            <td [ngStyle]="{color: (data?.attElig.includes('NE')) ? 'red' : 'black', 'font-weight': 'bold'}">{{data?.attElig}}</td>
                            <td>{{data?.ongoingScore}}</td>
                            <td>{{data?.ongoingElig}}</td>
                            <td>{{data?.practicalScore}}</td>
                            <td>{{data?.practicalElig}}</td>
                            <td>{{data?.gradeCode}}</td>
                            <td>{{data?.gpaScore}}</td>
                            <td>{{data?.studentStatus}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer">
                <!-- <button type="button" class="btn btn-primary" (click)="">Yes</button> -->
                <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ "CLOSE" | translate | titlecase
                    }}</button>
            </div>
        </form>
    </div>
</div>

<!-- Cancel Model -->
<div class="modal fade" id="cancelExam" tabindex="-1" aria-labelledby="cancelExamLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body font-16 text-center d-flex justify-content-between">
                <div class="p-2">
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
                <div class="p-2"><b>{{ "ARE_YOU_SURE" | translate | titlecase }}</b></div>
                <a type="button" class="btn btn-link text-danger" data-dismiss="modal"
                    (click)="updateCourseStatus(currentStudentCourseId, 2)">{{ "YES_CANCEL_IT" | translate | titlecase
                    }}</a>
                <a type="button" class="btn btn-link text-grey" data-dismiss="modal"><i
                        class="fas fa-times-circle"></i></a>
            </div>
        </div>
    </div>
</div>

<!-- Modal editStudentCourseRemarkFile-->
<div class="modal fade" id="editStudentCourseRemarkFile" tabindex="-1" aria-labelledby="editStudentCourseRemarkFile"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <form class="modal-content col-md-12" [formGroup]="editRemarkForm" (change)="editRemarkFormChange()"
            (submit)="editRemarkFormSubmit()" enctype="multipart/form-data">
            <div class="modal-header">
                <h5 class="modal-title" id="DisableServiceDataLabel">{{ "EDIT_REMARKS" | translate | titlecase
                    }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" #closeEditRemarkPopup>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="card-body">
                <app-loader [show]="uploadingRemark"></app-loader>
                <div class="col-md-12 form-group" *ngIf="!uploadingRemark">
                    <label class="text-bold">{{ "REMARKS" | translate | titlecase }}</label>
                    <textarea class="form-control" formControlName="remarks"></textarea>
                    <div class="alert alert-danger py-1 mt-1"
                        *ngIf="editRemarkForm.controls.remarks.touched && editRemarkForm.controls.remarks.invalid && editRemarkForm.dirty">
                        {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                    </div>
                </div>
            </div>
            <div class="modal-footer" *ngIf="!uploadingRemark">
                <button type="submit" class="btn btn-primary">{{ "SAVE" | translate | titlecase
                    }}</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ "CLOSE" |
                    translate | titlecase
                    }}</button>
            </div>
        </form>
    </div>
</div>